import Cookies from 'js-cookie'
import { useCallback, useEffect, useState } from 'react'

import { useAccountReadContext } from '@context/AccountContextContext'

import {
  closeHubSpotChat,
  handleAuthenticatedUser,
  handleUnauthenticatedUser,
  loadHubSpotChatScript,
  openHubSpotChat,
} from '@utils/hubspot'

import { useFunctionalConsent } from '@analytics/consent'

import { useHubspotToken } from './useHubspotToken'

export const useHubSpotChatWidget = (): {
  isHubSpotVisible: boolean
  openHSChat: () => void
  closeHSChat: () => void
} => {
  const { email } = useAccountReadContext()
  const identificationToken = useHubspotToken()
  const hasFunctionalConsent = useFunctionalConsent()

  const [isChatOpen, setChatOpen] = useState(Cookies.get('hs-messages-is-open') === 'true')

  useEffect(() => {
    if (!hasFunctionalConsent) return
    loadHubSpotChatScript()
  }, [hasFunctionalConsent])

  useEffect(() => {
    if (!hasFunctionalConsent) return
    if (email && identificationToken) {
      handleAuthenticatedUser(email, identificationToken)
    } else {
      handleUnauthenticatedUser()
    }
  }, [email, identificationToken, hasFunctionalConsent])

  const openChat = useCallback(() => {
    openHubSpotChat()
  }, [])

  const closeChat = useCallback(() => {
    closeHubSpotChat()
    setChatOpen(false)
  }, [])

  useEffect(() => {
    const handleOpenHubSpotChat = () => {
      openChat()
    }

    document.addEventListener('open-hubspot-chat', handleOpenHubSpotChat)

    return () => {
      document.removeEventListener('open-hubspot-chat', handleOpenHubSpotChat)
    }
  }, [openChat])

  return {
    isHubSpotVisible: isChatOpen,
    openHSChat: openChat,
    closeHSChat: closeChat,
  }
}
